export default __webpack_public_path__ + "static/rsz_geom2-fdc926f807d868fb1f81a97aa8247e32.png";